import { set, toggle } from '@/utils/vuex';

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  setFormChanged: (state, payload) => {
    state.isFormChanged = payload;
  },
  setNextRoute: (state, payload) => {
    if (!payload) {
      state.nextRoute = null;
    } else {
      const { name, params, query, hash } = payload;
      state.nextRoute = { name, params, query, hash };
    }
  },
  setRootNavigation: (state, payload) => {
    state.menuRoot = payload;
  },
  setManualHistory: (state, payload) => {
    state.manualHistory = payload;
  },
  setTempHistory: (state, payload) => {
    state.tempHistory = payload;
  },

  addManualHistory: (state, payload) => {
    const { name, path, params, query, hash } = payload;
    state.tempHistory = [...state.manualHistory, { name, params, query, hash, path }];
  },

  commitManualHistory: state => {
    if (state.tempHistory !== null) {
      state.manualHistory = structuredClone(state.tempHistory);
    } else {
      state.manualHistory = [];
    }
    state.tempHistory = null;
  },
  pushManualHistory: (state, payload) => {
    const { name, path, params, query, hash } = payload;
    state.manualHistory = [...state.manualHistory, { name, params, query, hash, path }];
  },
};
